import { BUILD_MY_FEED } from "./constants";

export default function SaveButton(props) {
    return (
        <button
            onClick={props.onSave}
            disabled={props.disabled}
            className="sportsName buildFeed"
        >
            {BUILD_MY_FEED}
        </button>
    );
}
